import script from "./SidebarButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarButton.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarButton.vue?vue&type=style&index=0&id=0b87fdde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b87fdde"]])

export default __exports__